
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/notes/help/basics",
      function () {
        return require("private-next-pages/notes/help/basics.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/notes/help/basics"])
      });
    }
  